import { FormHelperText as MuiFormHelperText, type SxProps, type Theme } from '@mui/material';
import { useMemo } from 'react';

interface IProps {
    error: string | undefined;
    touched: boolean | undefined;
    sx?: SxProps<Theme>;
}

export function FormHelperText(props: IProps) {
    const helperText = useMemo(() => {
        if (props.touched && props.error) {
            return props.error;
        }
        return undefined;
    }, [props.touched, props.error]);

    return <MuiFormHelperText sx={props.sx}>{helperText}</MuiFormHelperText>;
}
